var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3003_11859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9812 22.65C17.8737 22.65 22.65 17.8822 22.65 12C22.65 6.11777 17.8737 1.34998 11.9812 1.34998C6.39126 1.34998 1.8058 5.64235 1.34998 11.1045H15.4514V12.8954H1.34998C1.8058 18.3576 6.39126 22.65 11.9812 22.65Z",
    fill: "#2B50F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3003_11859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3,
    height: 21.3,
    fill: "white",
    transform: "translate(1.34998 1.34998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBase);
export default __webpack_public_path__ + "static/media/base.2cae4a0a9c6f130fb98b0ab08d383bfc.svg";
export { ForwardRef as ReactComponent };